import Layout from "./components/common/Layout";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import Menu from "./components/Menu";
import { useEffect, useState } from "react";
import { loadWeb3 } from "./core/web3";
import WalletNot from "./components/WalletNot";
import { onConnect } from "./core/web3";

function App() {
  const [wallet, setWallet] = useState(true);
  const onConnect1 = async () => {
    let res = await onConnect();
    setWallet(res.address != "");
  };

  useEffect(() => {
    loadWeb3();
    onConnect1();
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {wallet ? (
            <Route exact path="/Roulette" element={<Menu />} />
          ) : (
            <Route exact path="/Roulette" element={<WalletNot />} />
          )}
          <Route
            exact
            path="/"
            element={<Layout wallet={wallet} setWallet={setWallet} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
